import { CSSResult, LitElement, html, TemplateResult, PropertyValueMap } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { router } from "./routes";

// Styling
import css from "./maz-app.scss";

@customElement("maz-app")
export class MaziCraftApplication extends LitElement {
  static get styles(): CSSResult { return css; }

  /**
   * The title attribute of the page
   */
  @property({type: String, reflect: true}) title = "";

  /**
   * The target for the router
   */
  @query("#outlet") outlet: any;

  /**
   * Called when the application component is first attached to the DOM
   * @param changedProperties	Map of changed properties
   */
  firstUpdated(changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>) {
    super.firstUpdated(changedProperties);
    router.setOutlet(this.outlet);
  }

  /**
   * Method to render the component
   * @returns HTML template
   */
  render(): TemplateResult {
    return html`
      <header>
        <div class="logo">
          <a href="/" title="Home"><img src="/assets/images/mazicraft.png" alt="MaziCraft" /></a>
        </div>
        <nav class="menu">
          <ul>
            <li><a href="/plushies">Plushies</a></li>
            <li><a href="/portals">Portals</a></li>
            <li><a href="/resourcepacks">Resource Packs</a></li>
            <li><a href="/skins">Skins</a></li>
            <li><a href="/links">Links</a></li>
          </ul>
        </nav>
      </header>
      <main>
        <div id="outlet">
        </div>
      </main>
      <footer>
        <div class="logo">
          <img src="/assets/images/mazicrafter.png" alt="MaziCrafter" />
        </div>
        <div class="text">
          &copy; 2025 MaziCrafter
        </div>
        <nav class="menu">
          <ul>
            <li><a href="/plushies">Plushies</a></li>
            <li><a href="/portals">Portals</a></li>
            <li><a href="/resourcepacks">Resource Packs</a></li>
            <li><a href="/skins">Skins</a></li>
            <li><a href="/links">Links</a></li>
          </ul>
        </nav>
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "maz-app": MaziCraftApplication;
  }
}